<script>
  import {coinUtil} from '@/helper/coin';
  import {coinOptions$} from '@/streams/coin';
  import {currencies$} from '@/streams/config/currency';
  import Select from '@/widgets/Select.svelte';
  import SelectSearch from '@/widgets/SelectSearch.svelte';

  export let isSearch = false;
  export let coin = '';
  export let converter = function (options) {
    return options;
  };
  export let isCryptoCoin = false;

  let className = '';
  export {className as class};

  let selectOption = [];
  let displayBaseCurrency = coin;

  $: updateCoinOptions(isCryptoCoin, $coinOptions$);
  $: updateDisplayBaseCurrency($currencies$, coin);

  function updateCoinOptions(isCryptoCoin, coinOptions) {
    selectOption = isCryptoCoin ? coinOptions.filter((item) => !['USD', 'ETHS'].includes(item.value)) : coinOptions;
  }

  function updateDisplayBaseCurrency(currencies, coin) {
    const item = currencies.find((o) => o.currency === coin);
    if (item) {
      displayBaseCurrency = item.displayCurrency;
    }
  }
</script>

<style>
  .w18 {
    width: 18px;
  }
  .ml8 {
    margin-left: 8px;
  }
</style>

{#if isSearch}
  <SelectSearch type="underline" class="select-coin cp {className}" bind:value={coin} options={isCryptoCoin ? selectOption : converter($coinOptions$)} on:change>
    <div slot="displayItem" class="df aic">
      <img class="w18" src={coinUtil.getUrl(coin)} alt="Coin" />
      <span class="ml8 {coin}">{displayBaseCurrency}</span>
    </div>
    <div slot="item" let:option class="df aic">
      <img class="w18" src={coinUtil.getUrl(option.value)} alt="Coin" />
      <span class="ml8 {option.text}">{option.text}</span>
    </div>
  </SelectSearch>
{:else}
  <Select type="border" class="select-coin cp {className}" bind:value={coin} options={isCryptoCoin ? selectOption : converter($coinOptions$)} on:change>
    <div slot="displayItem" class="df aic">
      <img class="w18" src={coinUtil.getUrl(coin)} alt="Coin" />
      <span class="ml8 {coin}">{coin}</span>
    </div>
    <div slot="item" let:option class="df aic">
      <img class="w18" src={coinUtil.getUrl(option.value)} alt="Coin" />
      <span class="ml8 {option.text}">{option.text}</span>
    </div>
  </Select>
{/if}
